/** @type {import("@types/tailwindcss/tailwind-config").TailwindConfig } */

const typography = require("@tailwindcss/typography")
const forms = require("@tailwindcss/forms")
const lineClamp = require("@tailwindcss/line-clamp")
const defaultTheme = require("tailwindcss/defaultTheme")
const colors = require("tailwindcss/colors")

module.exports = {
  content: ["./**/*.tsx"],
  theme: {
    colors: {
      brand: {
        50: "hsl(var(--color-brand-hue), 50%, 98%)",
        100: "hsl(var(--color-brand-hue), 50%, 96%)",
        200: "hsl(var(--color-brand-hue), 50%, 94%)",
        300: "hsl(var(--color-brand-hue), 50%, 90%)",
        400: "hsl(var(--color-brand-hue), 50%, 86%)",
        500: "hsl(var(--color-brand-hue), 50%, 76%)",
        600: "hsl(var(--color-brand-hue), 50%, 66%)",
        700: "hsl(var(--color-brand-hue), 50%, 56%)",
        800: "hsl(var(--color-brand-hue), 50%, 36%)",
        900: "hsl(var(--color-brand-hue), 50%, 26%)",
        accent: "hsl(var(--color-brand-hue), 80%, 60%)",
        "accent-hover": "hsl(var(--color-brand-hue), 80%, 50%)",
      },
      "system-message": {
        success: {
          text: "#00664D",
          bg: "#DAF2E5",
        },
        information: {
          text: "#0552BE",
          bg: "#D7E9FF",
        },
        error: {
          text: "#CC2C41",
          bg: "#FFE9ED",
        },
      },
      gray: colors.gray,
      white: colors.white,
      transparent: colors.transparent,
      inherit: colors.inherit,
    },
    boxShadow: {
      sm: "0px 10px 10px -5px rgba(17, 24, 39, 0.04)",
      lg: "0px 10px 10px -5px rgba(17, 24, 39, 0.04), 0px 20px 25px -5px rgba(17, 24, 39, 0.1)",
      none: "none",
    },
    extend: {
      fontFamily: {
        sans: ["Inter var", ...defaultTheme.fontFamily.sans],
      },
      maxWidth: {
        "8xl": "83rem",
      },
      borderRadius: {
        sm: "1px",
      },
      lineHeight: {
        3.5: "0.875rem",
      },
      keyframes: {
        "slide-in-out": {
          "10%": {
            transform: "translateX(0)",
          },
          "90%": {
            transform: "translateX(0)",
          },
        },
        "slide-out": {
          "0%": {
            transform: "translateX(0)",
          },
        },
      },
      animation: {
        "slide-in-out": "slide-in-out 5s",
        "slide-out": "slide-out 500ms",
      },
      fontSize: {
        "h1-desktop": ["48px", "56px"],
        "h2-desktop": ["32px", "40px"],
        "h3-desktop": ["24px", "36px"],
        "h4-desktop": ["18px", "26px"],
        "p1-desktop": ["24px", "36px"],
        "p2-desktop": ["18px", "28px"],
        "p3-desktop": ["16px", "26px"],
        "p4-desktop": ["14px", "24px"],
        "h1-mobile": ["24px", "32px"],
        "h2-mobile": ["18px", "26px"],
        "h3-mobile": ["18px", "26px"],
        "h4-mobile": ["12px", "18px"],
        "p1-mobile": ["16px", "24px"],
        "p2-mobile": ["16px", "24px"],
        "p3-mobile": ["12px", "18px"],
        "p4-mobile": ["12px", "18px"],
      },
    },
  },
  plugins: [typography, forms, lineClamp],
}
